import React from "react";

const Slash = () => {
  return <span className={"highlight font-bold"}>&nbsp;/</span>;
};

export default Slash;
